export function init_faq() {

    // Open faq answer
    const QUESTIONS = document.querySelectorAll('.c-faq__question');

    for (let i = 0; i < QUESTIONS.length; i++) {
        const question = QUESTIONS[i];

        question.addEventListener('click', function (e) {
            const ANSWER = this.nextElementSibling;

            if (ANSWER.style.maxHeight) {
                ANSWER.style.maxHeight = null;
            } else {
                ANSWER.style.maxHeight = ANSWER.scrollHeight + "px";
            }
            e.preventDefault();
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/faq.js